"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rmChallenge = exports.matchChallenge = exports.getPkceCodeVerifier = exports.getCodeVerifierForChallenge = exports.cacheChallenge = void 0;
var _plain = _interopRequireDefault(require("./pkce/plain.js"));
var _S = _interopRequireDefault(require("./pkce/S256.js"));
var _GeneralError = _interopRequireDefault(require("./error/GeneralError.js"));
var _errorCode = require("./error/error-code.js");
var _AuthError = _interopRequireDefault(require("./error/AuthError.js"));
var _validation = require("./utils/validation.js");
var _session = require("./session.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getPkceCodeVerifier = function getPkceCodeVerifier(method) {
  if (method === 'plain') {
    return (0, _plain["default"])();
  } else if (method === 'S256') {
    return (0, _S["default"])();
  }
  throw new _GeneralError["default"](_errorCode.GENERAL, 'Unrecognised PKCE format');
};
exports.getPkceCodeVerifier = getPkceCodeVerifier;
var cacheChallenge = function cacheChallenge(cacheName) {
  return function (codeChallenge) {
    if (!(0, _validation.isStringWithLength)(codeChallenge === null || codeChallenge === void 0 ? void 0 : codeChallenge.challenge) || !(0, _validation.isStringWithLength)(codeChallenge === null || codeChallenge === void 0 ? void 0 : codeChallenge.verifier)) {
      throw new _GeneralError["default"](_errorCode.GENERAL, 'Client PKCE challenge is not valid');
    }
    var currentStore = (0, _session.getItemJSON)(cacheName) || {};
    var challenge = codeChallenge.challenge,
      verifier = codeChallenge.verifier;
    currentStore[challenge] = verifier;
    (0, _session.setItem)(cacheName)(JSON.stringify(currentStore));
  };
};
exports.cacheChallenge = cacheChallenge;
var getCodeVerifierForChallenge = function getCodeVerifierForChallenge(cacheName) {
  return function (challenge) {
    var challengeStore = (0, _session.getItemJSON)(cacheName) || {};
    if (!(challenge in challengeStore)) {
      throw new _GeneralError["default"](_errorCode.GENERAL, 'PKCE code challenge failed');
    }
    return challengeStore[challenge];
  };
};
exports.getCodeVerifierForChallenge = getCodeVerifierForChallenge;
var matchChallenge = function matchChallenge(cacheName) {
  return function (matchChallenge) {
    var challengeStore = (0, _session.getItemJSON)(cacheName) || {};
    if (!(matchChallenge in challengeStore)) {
      throw new _AuthError["default"](_errorCode.AUTH, 'PKCE code challenge failed');
    }
    var verifier = challengeStore[matchChallenge];
    delete challengeStore[matchChallenge];
    (0, _session.setItem)(cacheName)(JSON.stringify(challengeStore));
    return {
      challenge: matchChallenge,
      verifier: verifier
    };
  };
};
exports.matchChallenge = matchChallenge;
var rmChallenge = function rmChallenge(cacheName) {
  return function (challenge) {
    var challengeStore = (0, _session.getItemJSON)(cacheName) || {};
    if (!(challenge in challengeStore)) {
      console.warn('challenge not present');
      return;
    }
    var challengeKey = challengeStore[challenge],
      newChallengeStore = _objectWithoutProperties(challengeStore, [challenge].map(_toPropertyKey));
    (0, _session.setItem)(cacheName)(JSON.stringify(newChallengeStore));
    return undefined;
  };
};
exports.rmChallenge = rmChallenge;